import { getBranch } from "utils/utils";
import moment from "moment";
import { UPDATE_SEARCHTDATA_DANHSACHCHINHANH } from "../../../actions/HeThong/DanhSachChiNhanh/actionTypes";

const initialState = {
  pageIndex: 1,
  pageSize: 20,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchDanhSachChiNhanh = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DANHSACHCHINHANH:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDanhSachChiNhanh;
